import { createSlice } from "@reduxjs/toolkit";

import {
  getCashFlowThunk,
  createCashFlowThunk,
  updateCashFlowThunk,
  deleteCashFlowThunk,
  verifyCashFlowThunk,
  // verifyCashFlowThunk,
} from "state/action/cash_flow";

// Initial state
const initialState = {
  // Get CashFlow inisial state
  getCashFlow: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create CashFlow inisial state
  createCashFlow: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update CashFlow inisial state
  updateCashFlow: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update CashFlow inisial state
  verifyCashFlow: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete CashFlow inisial state
  deleteCashFlow: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  createCashFlowInputBody: {
    code: "",
    CashFlow_name: "",
    division: "",
    description: "",
  },
  selectedCashFlow: {
    revenue_recognation: [],
    overall_status: "",
    verifications: [],
    pks: "",
  },
  verifyCashFlowInputBody: {
    id: "",
    role: "",
    status: "",
    notes: "",
    user_id: "",
  },

  // CashFlow object value
  cashFlow_object_value: "",
};

export const cashFlowSlice = createSlice({
  name: "cashFlow",
  initialState,
  reducers: {
    setGetCashFlowObjectValue: (state, action) => {
      return {
        ...state,
        CashFlow_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetCashFlowObjectValue: (state, _) => {
      return {
        ...state,
        CashFlow_object_value: "",
      };
    },
    setCreateCashFlowInputBody: (state, action) => {
      return {
        ...state,
        createCashFlowInputBody: action.payload,
      };
    },
    setVerifyCashFlowInputBody: (state, action) => {
      return {
        ...state,
        verifyCashFlowInputBody: action.payload,
      };
    },
    setSelectedCashFlow: (state, action) => {
      return {
        ...state,
        selectedCashFlow: action.payload,
      };
    },
    setClearCreateCashFlowInputBody: (state, _) => {
      return {
        ...state,
        createCashFlowInputBody: {
          code: "",
          CashFlow_name: "",
          division: "",
          description: "",
        },
      };
    },
    setClearCreateCashFlow: (state, _) => {
      return {
        ...state,
        createCashFlow: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearGetCashFlow: (state, _) => {
      return {
        ...state,
        getCashFlow: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateCashFlow: (state, _) => {
      return {
        ...state,
        updateCashFlow: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteCashFlow: (state, _) => {
      return {
        ...state,
        deleteCashFlow: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllCashFlowState: (state, _) => {
      return {
        ...state,
        // Get CashFlow inisial state
        getCashFlow: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create CashFlow inisial state
        createCashFlow: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update CashFlow inisial state
        updateCashFlow: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete CashFlow inisial state
        deleteCashFlow: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // CashFlow object value
        cashFlow_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get CashFlow reducer
      .addCase(getCashFlowThunk.pending, (state, _) => {
        return {
          ...state,
          getCashFlow: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getCashFlowThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getCashFlow: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getCashFlowThunk.rejected, (state, action) => {
        return {
          ...state,
          getCashFlow: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create CashFlow reducer
      .addCase(createCashFlowThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createCashFlowThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createCashFlowThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update CashFlow reducer
      .addCase(updateCashFlowThunk.pending, (state, _) => {
        return {
          ...state,
          updateCashFlow: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateCashFlowThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateCashFlow: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateCashFlowThunk.rejected, (state, action) => {
        return {
          ...state,
          updateCashFlow: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      .addCase(verifyCashFlowThunk.pending, (state, _) => {
        return {
          ...state,
          verifyCashFlow: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(verifyCashFlowThunk.fulfilled, (state, action) => {
        return {
          ...state,
          verifyCashFlow: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(verifyCashFlowThunk.rejected, (state, action) => {
        return {
          ...state,
          verifyCashFlow: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const cashFlowAction = {
  ...cashFlowSlice.actions,
  getCashFlowThunk,
  createCashFlowThunk,
  updateCashFlowThunk,
  deleteCashFlowThunk,
  verifyCashFlowThunk,
};

export function selectCashFlowObjectValue(state) {
  return state?.cashFlow?.cashFlow_object_value;
}

export function selectCashFlow(state) {
  return state?.cashFlow;
}

export default cashFlowSlice.reducer;
